    angular.module('qkr')
        .factory('sessionExpiryService', sessionExpiryService);
    sessionExpiryService.$inject = ['$window', '$http', 'appConfig', '$log'];
    function sessionExpiryService($window, $http, appConfig, $log) {
         return {
             continueSession() {
                 const keepAliveResponse = response => {
                     if (response.data && response.data.value === false) {
                         this.logout();
                     }
                 };
                 $http.post(appConfig.apiUrl + 'session/keepUserSessionAlive', {value: true})
                     .then(keepAliveResponse)
                     .catch(reason => $log.info(reason));
             },
             logout() {
                 $window.location.href = appConfig.logoutUrl + '?timeout=true';
             }
         };
    }




// WEBPACK FOOTER //
// ./src/sessionExpiry/services/session.expiry.services.js